import { useRef } from "react";
import toast from "react-hot-toast"

function AppIcon({
  icon,
  name,
  onClickHandler,
}: {
  icon: JSX.Element;
  name: string;
  onClickHandler: () => void;
}) {
  const isSmallScreen = window.matchMedia("(max-width: 1024px)").matches;
  const clickTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleClick = () => {
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
      clickTimeout.current = null;
    }

    clickTimeout.current = setTimeout(() => {
      if (isSmallScreen) {
        onClickHandler();
      } else {
        toast("Hey, Double click to open", {
          icon: "👋",
        });
      }
    }, 250);
  };

  const handleDoubleClick = () => {
    if (clickTimeout.current) {
      clearTimeout(clickTimeout.current);
      clickTimeout.current = null;
    }
    if (!isSmallScreen) {
      onClickHandler();
    }
  };

  return (
    <button
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
      className={`inline-flex space-y-1 cursor-pointer w-24 h-28 flex-col items-center justify-center rounded-md p-2 text-zinc-900 dark:text-zinc-100 hover:bg-zinc-800/60 active:bg-zinc-800/80 active:border-zinc-700`}
    >
      <span className="text-4xl">{icon}</span>
      <span className="text-sm overflow-clip text-zinc-100">{name}</span>
    </button>
  );
}

export default AppIcon